import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import styles from './Intro.module.css';

const Intro = ({ onComplete }) => {
  const quotes = [
  "Eating code... Sleeping error...",
  "Initializing Mastermind Protocol...",
  "Just a moment, compiling awesomeness..."
];
const quote = quotes[Math.floor(Math.random() * quotes.length)];
  
  // Animation settings
  useEffect(() => {
    // 3.5 second baad intro khatam ho jayega
    const timer = setTimeout(() => {
      onComplete();
    }, 3500); 
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <motion.div 
      className={styles.introScreen}
      initial={{ y: 0 }}
      exit={{ y: '-100vh', transition: { duration: 0.8, ease: [0.76, 0, 0.24, 1] } }} // Smooth Slide Up Exit
    >
      <div className={styles.textContainer}>
        {quote.split(" ").map((word, index) => (
          <motion.span
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.2 }} // Har word thoda ruk ke aayega
            className={styles.word}
          >
            {word}&nbsp;
          </motion.span>
        ))}
      </div>
      
      <motion.div 
        className={styles.loaderLine}
        initial={{ width: 0 }}
        animate={{ width: '200px' }}
        transition={{ duration: 3, ease: "easeInOut" }}
      />
    </motion.div>
  );
};

export default Intro;